import { Box } from '@mui/material';
import { DataGridPremium, GridCellParams } from '@mui/x-data-grid-premium';
import React from 'react';

import { datagridFilterPanelAttributes } from '../../../utils';
import { CustomToolbar } from '../../toolbar';
import { EditNotesModal } from './editNotesModal';
import { getInvoiceHistoryColumns } from './invoiceHistoryTableColumns';

export const InvoiceHistoryTable = ({ timezone, refetch, loading, historyData, setShowDialog, setShowSnackbar }) => {
	const handleCellClick = async (params: GridCellParams) => {
		if (params.field === 'actions') {
			const notesDialog = (
				<EditNotesModal
					rowId={params.row.id}
					rowType={params.row.rowType}
					existingNotes={params.row.notes || null}
					refetch={refetch}
					handleClose={() => setShowDialog(null)}
					setShowSnackbar={setShowSnackbar}
				/>
			);
			setShowDialog(notesDialog);
		}
	};

	return (
		<Box sx={{ height: '65vh', width: '100%', marginTop: '30px' }} data-cy='invoice-history-table-container'>
			<DataGridPremium
				sx={{
					overflow: 'scroll',
					height: '50vh',
				}}
				disableRowSelectionOnClick
				rows={(!loading && historyData) || []}
				columns={getInvoiceHistoryColumns(timezone)}
				loading={loading}
				slots={{
					toolbar: () => <CustomToolbar />,
				}}
				slotProps={{ filterPanel: { ...datagridFilterPanelAttributes } }}
				onCellClick={handleCellClick}
			/>
		</Box>
	);
};
